import { collection, doc, onSnapshot } from 'firebase/firestore';
import { db } from '../config/firebase';

/*
 * Padrón de clientes por empleado comercial (colección `comercialesClientes`).
 *
 * Lo escribe únicamente la Cloud Function de sincronización con el Sistema de
 * Gestión Comercial (SGC), en la misma corrida que el padrón de productores: un
 * documento por comercial, con id = email en minúsculas y la lista de números de
 * comitente de los clientes que tiene asignados allá.
 *
 * A diferencia de `productores`, esto NO define permisos: un comercial es
 * personal interno y las reglas de Firestore lo dejan leer todo. Es el alcance
 * del Dashboard de Saldos, que agrega solo sus cuentas.
 */
const COLLECTION = 'comercialesClientes';

export const normalizeComercialEmail = (email) => String(email || '').trim().toLowerCase();

const toComercial = (snap) => {
  if (!snap.exists()) return null;
  const data = snap.data();
  return {
    id: snap.id,
    ...data,
    comitentes: Array.isArray(data.comitentes) ? data.comitentes.map(String) : [],
    clientes: Array.isArray(data.clientes) ? data.clientes : [],
    clientesSinComitente: Array.isArray(data.clientesSinComitente) ? data.clientesSinComitente : [],
  };
};

/**
 * Suscribe al padrón completo de comerciales (solo personal interno). Lo usa el
 * panel Productores para avisar las bajas que la sincronización dejó pendientes.
 */
export const subscribeComerciales = (onData, onError) => onSnapshot(
  collection(db, COLLECTION),
  (snapshot) => onData(snapshot.docs.map(toComercial).filter(Boolean)),
  (error) => {
    console.error('comercialesClientesService.subscribeComerciales failed:', error);
    if (onError) onError(error);
  },
);

/**
 * Suscribe al documento del comercial con ese email. Emite `null` si no figura
 * en el padrón (no está cargado como empleado comercial en el SGC).
 */
export const subscribeComercialPorEmail = (email, onData, onError) => {
  const id = normalizeComercialEmail(email);
  if (!id) {
    onData(null);
    return () => {};
  }
  return onSnapshot(
    doc(db, COLLECTION, id),
    (snap) => onData(toComercial(snap)),
    (error) => {
      console.error('comercialesClientesService.subscribeComercialPorEmail failed:', { id, error });
      if (onError) onError(error);
    },
  );
};
